<div class="best-selling-container">
    <div class="best-selling-content container">
        <div class="best-selling-header">
            <div class="left-section">
                <p class="best-selling-title font-poppins">Best Selling Toys</p>
                <p class="best-selling-subtitle">Our most loved block sets by parents and kids</p>
            </div>

            <a routerLink="/products" [queryParams]="{ category: 'bestSeller' }" class="right-section">
                <p class="view-all">View All</p>
                <mat-icon [svgIcon]="'rightarrow'" class="right-arow-icon"></mat-icon>
            </a>
        </div>
        <div class="best-selling-products">
            @for (product of bestSellerProducts; let i = $index; track i) {
            <app-product-card
                class="card"
                [product]="product"
                [imageBgClass]="'product-image-gradient' + ((i % 3) + 1)"
            ></app-product-card>
            }
        </div>
    </div>
</div>
